import React from 'react'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import { constants } from '../Constants'

interface MapToPatientOptionsProps {
  mapTo: string
  mapToPatient: string
  handleMapToPatientChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const MapToPatientOptions: React.FC<MapToPatientOptionsProps> = ({
  mapTo,
  mapToPatient,
  handleMapToPatientChange,
}) => {
  const isHomekare = mapTo === constants?.homekare
  const mapToPatientOptions = [
    { value: 'existing', label: 'Existing' },
    { value: 'new', label: 'New' },
  ]
  return (
    <FormControl>
      <RadioGroup
        row
        id='map-to-options'
        value={mapToPatient}
        onChange={handleMapToPatientChange}
      >
        {mapToPatientOptions?.map((option) => {
          return (
            <FormControlLabel
              key={option.value}
              value={option.value}
              label={option.label}
              control={<Radio />}
            />
          )
        })}
        {!isHomekare && (
          <FormControlLabel
            value='unidentified'
            label='Unidentified'
            control={<Radio />}
          />
        )}
      </RadioGroup>
    </FormControl>
  )
}
